import { render, staticRenderFns } from "./ScoringRequestResult.vue?vue&type=template&id=30c93b63&lang=pug&"
import script from "./ScoringRequestResult.vue?vue&type=script&lang=js&"
export * from "./ScoringRequestResult.vue?vue&type=script&lang=js&"
import style0 from "./ScoringRequestResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ScoringRequestResult.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports